import { useState } from 'react';
import TranslationPageLayout from '../../Components/shared/TranslationPageLayout.js';
import CommonImage from '../../Components/shared/ImageComponent';
// import Footer from '../../Components/shared/Footer';
import { birthDocumentTranslationData } from '../../Components/shared/faqList';
import FAQ from '../../Components/shared/FAQ';
// import Navbar from '../../Components/shared/Header';
import DocumentType from "../../Components/shared/DocumentType";
import { BirthDocumentTranslationDocumentTypes as bdocs } from "../../Components/shared/DocumentType/documentTypes.js"
import { IMAGES } from './imagesImports.js';
import HorizontleButtons from '../../Components/shared/HorizontleButtons.js';
import { useHorizontalScroll } from "../../Hooks/useHorizontalScroll.js";
import {
  section2Images,
  section3Images,
  section4Images,
  section5Images,
  section6Images,
  section7Images,
  section8Images
} from "./imagesItem.js"
import { SECTION_9_TEXT } from './textImport.js';
import "./index.css"
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount';
import { useLocation } from 'react-router-dom';
import Navbar from '../HomePage/header.js';
import Footer from '../HomePage/footer.js';

const BirthCertificateDocumentTranslationPage = ({ windowSize }) => {

  const { pathname } = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);

  const {
    scrollRef: section3BirthRef,
    scrollLeft: section3Left,
    scrollRight: section3Right,
  } = useHorizontalScroll(300);

  const {
    scrollRef: section4BirthRef,
    scrollLeft: section4Left,
    scrollRight: section4Right,
  } = useHorizontalScroll(300);

  const {
    scrollRef: section7BirthRef,
    scrollLeft: section7Left,
    scrollRight: section7Right,
  } = useHorizontalScroll(300);

  const {
    scrollRef: section8BirthRef,
    scrollLeft: section8Left,
    scrollRight: section8Right,
  } = useHorizontalScroll(300);

  const handleLoginOpen = (newState) => {
      setIsModalOpen(newState);
  };

  const handleCreateAccountOpen = (newState) => {
      setIsCreateAccountOpen(newState);
  };

  return (
    <TranslationPageLayout>

      <SignInForm
          open={isModalOpen}
          isLoginFormOpen={handleLoginOpen}
          isCreateAccountOpen={handleCreateAccountOpen}
      />
      <CreateAccount
          open={isCreateAccountOpen}
          isCreateAccountOpen={handleCreateAccountOpen}
          isLoginFormOpen={handleLoginOpen}
      />

      {/* Birth Hero Section */}
      <div role='Birth Hero Section' className='w-full'>
        <div className='birth-HeroSection'>
          <Navbar
            windowSize={windowSize}
            isLoginFormOpen={handleLoginOpen}
          />
          <div role='content-section' className='birth-HeroSectionContent'>
            <div className='birth-contentTitle'>
              <div className='birth-contentTitleLarge'>Certified Translation of <span className='birth-title-orange'>Birth Certificate</span> by <span className='birth-title-green'>eVerbary</span> </div>
              <div className='birth-contentTitleSmall'>When you need a certified translation of your birth certificate for USCIS, legal filings, or official purposes, eVerbary delivers accurate, fast, and professional services. Our certified birth certificate translation services are valid in all 50 states and meet the requirements set by U.S. Citizenship and Immigration Services (USCIS).</div>
            </div>
            <div className='birth-contentSection2 w-full'>
              {/* <div className='flex flex-col gap-3 items-center'> */}
              <img src={IMAGES?.HEROIMG} alt='section2-image' />
              <p className='birth-contentSection2Text'>Whether your birth certificate was issued in Spanish, French, Arabic, or any other foreign language, our translation team is ready to translate your birth certificate with full English accuracy.</p>
              <p className='birth-contentSection2TextSmall'>We provide a certificate of translation accuracy with every document, guaranteeing that the translation is complete and accurate.</p>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Why You Need a Certified Translation of Your Birth Certificate */}
      <div className='birth-section2'>
        <div role='section2-header' className='birth-section2Header'>
          <span className='birth-section2HeaderHeading'>Why You Need a Certified Translation <br /> of Your Birth Certificate</span>
        </div>
        <div role="section2-Image" className="birth-section2Images scrollbar-hide">
          {section2Images.map((item, index) => (
            <div
              key={index}
              style={{ backgroundImage: `url(${item?.src})` }}
              className='birth-section2ImageItem'
            >
              <div className='imm-sec2-text'>{item?.text}</div>
            </div>
          ))}
        </div>
      </div>

      {/* What Is a Certified Birth Certificate Translation? */}
      <div className='birth-section3'>
        <div role='section3-header' className='birth-section3Header'>
          <div className='birth-section3HeaderHeading'>Certified Medical Translation You Can Rely On</div>
          <div className='birth-section3HeaderText'>A certified translation of your birth certificate includes:</div>
        </div>
        <div ref={section3BirthRef} role='section5-Images' className='birth-section3Images scrollbar-hide'>
          {section3Images?.map((item, idx) => (
            <div key={idx} className='birth-section3Image'>
              <CommonImage src={item?.src} alt={item?.alt} width={43} height={43} />
              <div className='birth-imageBottomText'>{item?.text}</div>
            </div>
          ))}
        </div>
        <HorizontleButtons
          scrollLeft={section3Left}
          scrollRight={section3Right}
          type=''
        />
        <span role='section5-bottom-text' className='medical-section5HBottomText' style={{paddingLeft:'0px'}}>The translation is approved for submission to USCIS, legal institutions, and government agencies. <br /> We guarantee that the certified translation is accurate, complete, and formatted according to USCIS guidelines.</span>
      </div>

      {/* Who Needs Birth Certificate Translation Services? */}
      <div className='birth-section4-container'>
          <div className='birth-section4'>
          <div role='section4-header' className='birth-section4Header'>
            <div className='birth-section4HeaderHeading'>Who Needs Birth Certificate Translation Services?</div>
            <div className='birth-section4HeaderText'>You may need to translate your birth certificate if you are:</div>
          </div>
          <div ref={section4BirthRef} role="section4-Images" className="birth-section4Images scrollbar-hide">
            {section4Images?.map((item, idx) => (
              <div key={idx} className="birth-section4ImageItem">
                <CommonImage src={item?.src} alt={item?.alt} width={43} height={43} />
                <div className="birth-imageBottomText">{item?.text}</div>
              </div>
            ))}
          </div>
          <HorizontleButtons
            className='pr-5'
            scrollLeft={section4Left}
            scrollRight={section4Right}
            type='blue'
          />
          <span role='section4-bottom-text' className='birth-section4HBottomText'>The certified birth certificate translation is required for a variety of purposes, especially when the original document is not in English.</span>
        </div>
      </div>
      

      {/* What Sets Our Translation Services Apart */}
      <div className='birth-section5'>
        <div className='birth-section5Container'>
          <div className='birth-section5Header'>
            <span className='birth-section5HeaderHeading'>Get Your Birth Certificate Translated and Certified</span>
            <span className='birth-section5HeaderText'>At eVerbary, we translate birth certificates issued all over the world. Our translation service covers:</span>
          </div>
          <div className="birth-section5Images">
            {section5Images.map((item, idx) => (
              <div key={idx} className="birth-section5ImageItem">
                <CommonImage src={item?.src} alt={item?.alt} width={idx === 2 ? 80 : 48}
                  height={idx === 2 ? 80 : 48} />
                <div className="birth-section5CardText">
                  {item?.text}
                </div>
              </div>
            ))}
            <span className='birth-section5BottomText'>Translations are accepted by USCIS and other U.S. institutions. We provide certified translations with a USCIS acceptance guarantee.</span>
          </div>
        </div>
      </div>

      {/* The Translation Process Is Simple */}
      <div className='birth-section6'>
        <div role='section6-header' className='birth-section6Header'>
          <span className='birth-section6HeaderHeading'>The Translation Process Is Simple</span>
        </div>
        <div role='section6-Images-and-text' className='birth-section6ImagesAndText'>
          <div role="section6-Images" className="birth-section6Images">
            {section6Images.map((item, idx) => (
              <div
                key={idx}
                style={{
                    maxWidth: windowSize.width < 640 ? '100%' : '203px',
                    minHeight: windowSize.width < 640 ? '246px' : '372px',
                    background : `${item?.backgroundColor}`
                }}
                className='birth-section6ImageItem relative'
              >
                <img className='rounded-4xl sm:w-auto w-[200px]' src={item?.src} />
                <div className='flex flex-col self-start mx-4 gap-1 absolute bottom-6'>
                  <span className='imm-sec5-heading min-w-[100%]'>{item?.heading}</span>
                  <span className='imm-sec5-desc'>{item?.description}</span>
                </div>
              </div>
            ))}
          </div>
          <span role='section6-Images-text' className='birth-section6ImagesText'>We offer translation turnaround times as fast as within 24 hours for 1-3 page documents.</span>
        </div>
      </div>

      {/* What Makes eVerbary the Right Choice? */}
      <div className="birth-section11">
        <div className="birth-section11Content">
          <div className="birth-section11ContentHeading">What Makes eVerbary the Right Choice?</div>
          <div className="birth-section11ContentText">eVerbary provides certified birth certificate translation services that meet USCIS standards. Our team has experience translating birth certificates in over 65 languages. Translations are completed by native-speaking professionals who understand the requirements of the immigration process and legal filings.</div>
          <div className="birth-section11ContentCard">We ensure every certified translation of your birth is accurate, with translations approved for citizenship and immigration services, marriage licenses, and academic applications.<br /> Our professional certified translation includes:</div>
        </div>
        <div className=''>
          <img src={IMAGES.BIRTHSECTION11IMG} alt='section11-image' />
        </div>
      </div>

      {/* Certified Translation Services with Notarization */}
      <div className='birth-section7-container'>
        <div className='birth-section7'>
          <div role='section7-header' className='birth-section7Header'>
            <div className='birth-section7HeaderHeading'>Certified Translation Services with Notarization</div>
            <div className='birth-section7HeaderText'>Need your certified birth certificate translation notarized? We can notarize your translation to meet specific requirements. Some institutions or agencies ask for a notarized certificate, especially for international document translation. <br /> Our notarization process includes:</div>
          </div>
          <div ref={section7BirthRef} role="section7-Images" className="birth-section7Images scrollbar-hide">
            {section7Images?.map((item, idx) => (
              <div key={idx} className="birth-section7Image">
                <CommonImage src={item?.src} alt={item?.alt} width={32} height={32} />
                <div className="medical-imageBottomText">{item?.text}</div>
              </div>
            ))}
          </div>
          <HorizontleButtons
            className='pr-5'
            scrollLeft={section7Left}
            scrollRight={section7Right}
            type=''
          />
          <span role='section5-bottom-text' className='medical-section5HBottomText birth-section7HBottomText'>Each service is tailored to the specific needs of the medical field. We ensure every translation is done with precision, care, and adherence to the highest standards.</span>
        </div>
      </div>

      {/* USCIS Certified Translations */}
      <div className='birth-section8-container'>
        <div className='birth-section8'>
          <div role='section8-header' className='birth-section8Header'>
            <div className='birth-section8HeaderHeading'>USCIS Certified Translations</div>
            <div className='birth-sectio8HeaderText'>We specialize in USCIS-certified translations. USCIS requires that the translator certify they are competent to translate the document and that the translation is complete and accurate. <br /> We follow USCIS standards for:</div>
          </div>
          <div ref={section8BirthRef} role="section8-Images" className="birth-section8Images scrollbar-hide">
            {section8Images?.map((item, idx) => (
              <div key={idx} className="birth-section8ImageItem">
                <CommonImage src={item?.src} alt={item?.alt} width={32} height={32} />
                <div className="birth-imageBottomText">{item?.text}</div>
              </div>
            ))}
          </div>
          <HorizontleButtons
            className='pr-5'
            scrollLeft={section8Left}
            scrollRight={section8Right}
            type='blue'
          />
          <span role='section8-bottom-text' className='birth-section8HBottomText'>Translations are delivered with a certificate of translation accuracy and formatted to meet USCIS guidelines.</span>
        </div>
      </div>

      {/* Professional Translation You Can Depend On */}
      <div className='birth-section9-container'>
        <div className='birth-section9'>
          <div className='birth-section9Content'>
            <span className='birth-section9ContentHeading'>Professional Translation You Can Depend On</span>
            <span className='birth-section9ContentCenterText'>Verbary has handled thousands of medical and personal document translations. Our translation team brings experience, professionalism, and a commitment to quality.We understand that a birth certificate is more than a document. It’s a record of identity required for a wide variety of purposes. We treat every translation with the care it deserves.</span>
            <span className='birth-section9ContentBottomText'>With eVerbary, you get:</span>
          </div>
          <div className='birth-section9Points'>
            {SECTION_9_TEXT?.map((item, index) => (
              <div className='birth-section9SinglePoint' key={index}>
                <CommonImage src={IMAGES.CHECKSQUARE} alt="tick square" width={24} height={24} />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <FAQ id='faqs-legal' faqData={birthDocumentTranslationData} />

      {/* Translate Birth Certificates with eVerbary */}
      <div className='birth-section10'>
        <div className='medical-section10Heading birth-section10Heading'>Translate <span>Birth Certificates<br /></span> with <span>eVerbary</span></div>
        <div className='medical-section10CenterText birth-section10TextOne'>If you need to translate your birth certificate, trust eVerbary to handle your translation with care and precision. We offer language services for every major language, and our certified translators produce accurate, reliable translations with fast turnaround.</div>
        <div className='medical-section10BottomText birth-section10TextTwo'>Whether for immigration, marriage, legal filings, or education, we’re here to help. Upload your documents and get your birth certificate translated by professionals.</div>
        <div className='medical-section10BottomText birth-section10TextThree'>Whether for immigration, marriage, legal filings, or education, we’re here to help. Upload your documents and get your birth certificate translated by professionals.</div>
      </div>

      {/* Footer */}
      <Footer windowSize={windowSize} />
    </TranslationPageLayout>
  )
}

export default BirthCertificateDocumentTranslationPage